"use strict";

var regexValidator = require('./regexValidator');
var _require = require('./errors'),
  InvalidVersionError = _require.InvalidVersionError;
var versionRegex = /^((?!\.\.)[a-zA-Z0-9.])+$/;
var validator = regexValidator(versionRegex, InvalidVersionError);
module.exports = function () {
  return {
    validate: function validate(version) {
      return validator.validate(version);
    }
  };
};
//# sourceMappingURL=versionValidator.js.map